module.exports = __webpack_public_path__ + "img/ba3.b97e0460.jpg";